var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",staticStyle:{"justify-content":"center","height":"100%","align-items":"center"}},[_c('h4',{staticStyle:{"color":"#FFF"}},[_vm._v(_vm._s(_vm.$t('general.comingSoon')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }